import {
    DEFAULT_MONTHS_UNTIL_DAILY_RECURRENCE_END,
    DEFAULT_WEEKS_UNTIL_WEEKLY_RECURRENCE_END,
    DEFAULT_YEARS_UNTIL_MONTHLY_RECURRENCE_END,
    RecurrenceConstants,
} from 'owa-recurrence-types';
import { DisplayDate, addMonths, addWeeks, addYears } from 'owa-datetime';

export default function getRecurrenceDefaultEnd(
    recurrenceType: string,
    startDate: DisplayDate
): DisplayDate {
    switch (recurrenceType) {
        case RecurrenceConstants.Daily:
            return getDailyRecurrenceDefaultEnd(startDate);
        case RecurrenceConstants.Weekly:
            return getWeeklyRecurrenceDefaultEnd(startDate);
        case RecurrenceConstants.Monthly:
            return getMonthlyRecurrenceDefaultEnd(startDate);
        case RecurrenceConstants.Yearly:
        case RecurrenceConstants.None:
        default:
            return null;
    }
}

function getDailyRecurrenceDefaultEnd(startDate: DisplayDate): DisplayDate {
    return addMonths(startDate, DEFAULT_MONTHS_UNTIL_DAILY_RECURRENCE_END);
}

function getWeeklyRecurrenceDefaultEnd(startDate: DisplayDate): DisplayDate {
    return addWeeks(startDate, DEFAULT_WEEKS_UNTIL_WEEKLY_RECURRENCE_END);
}

function getMonthlyRecurrenceDefaultEnd(startDate: DisplayDate): DisplayDate {
    return addYears(startDate, DEFAULT_YEARS_UNTIL_MONTHLY_RECURRENCE_END);
}
